import { useState } from "react";
import { ProfileDetailsProps } from "@/types/ProfileDetails";

export function useProfileDetails(props: ProfileDetailsProps) {
  const {
    bestFor,
    worksWith,
    whatWorkerDoes,
    onBestForChange,
    onWorksWithChange,
    onWhatWorkerDoesChange,
  } = props;

  const [newItem, setNewItem] = useState("");
  const [newBestForItem, setNewBestForItem] = useState("");
  const [newWhatWorkerDoesItem, setNewWhatWorkerDoesItem] = useState("");

  const handleAddItem = () => {
    const itemToAdd = props.worksWithInputValue !== undefined ? props.worksWithInputValue : newItem;

    if (itemToAdd.trim() && !worksWith.includes(itemToAdd.trim()) && onWorksWithChange) {
      onWorksWithChange([...worksWith, itemToAdd.trim()]);
      
      if (props.onWorksWithInputChange) {
        props.onWorksWithInputChange("");
      } else {
        setNewItem("");
      }
    }
  };

  const handleAddBestForItem = () => {
    if (!newBestForItem.trim()) {
      return;
    }
    if (onBestForChange) {
      onBestForChange({ ...bestFor, items: [...bestFor.items, newBestForItem.trim()] });
      setNewBestForItem("");
    }
  };

  const handleAddWhatWorkerDoesItem = () => {
    if (!newWhatWorkerDoesItem.trim()) {
      return;
    }
    if (onWhatWorkerDoesChange) {
      onWhatWorkerDoesChange([...whatWorkerDoes, newWhatWorkerDoesItem.trim()]);
      setNewWhatWorkerDoesItem("");
    }
  };

  const handleRemoveItem = (index: number) => {
    if (onWorksWithChange) {
      const updated = worksWith.filter((_, i) => i !== index);
      onWorksWithChange(updated);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleAddItem();
    }
  };

  return {
    newItem,
    setNewItem,
    newBestForItem,
    setNewBestForItem,
    newWhatWorkerDoesItem,
    setNewWhatWorkerDoesItem,
    handleAddItem,
    handleAddBestForItem,
    handleAddWhatWorkerDoesItem,
    handleRemoveItem,
    handleKeyPress,
  };
}
